import { Component, AfterViewInit, OnInit, Renderer2, PLATFORM_ID, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-identi-professionals',
  templateUrl: './identi-professionals.component.html',
  styleUrls: ['./identi-professionals.component.scss']
})
export class IdentiProfessionalsComponent implements OnInit, AfterViewInit {

  adminLoginUrl = environment.adminLoginUrl;
  googleformLink = 'https://docs.google.com/forms/d/e/1FAIpQLSfZYzeKkipookafLxaVaOEi8cynaNCAgebY3Hp72EIKr4mHVg/viewform'
  isBrowser: boolean;
  public companyPhoneNumber: string;
  // A keeper can only accept a ToK while on the premium plan, so the fee matches the premium annual price.
  public tokFee: string;

  constructor(
    private renderer: Renderer2,
    private router: Router,
    private library: FaIconLibrary,
    private configService: ConfigService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ){
    this.library.addIcons(faPlus, faMinus);
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.companyPhoneNumber = this.configService.getTextFromKey('company-phone-number');
    this.tokFee = this.configService.getTextFromKey('2-plan-yearly-price');
  }

  ngOnInit() {
    this.applyFooterColorChange();
  }

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.applyFooterColorChange();
      }
    });
  }

  private applyFooterColorChange() {
    if (!this.isBrowser) return;

    const element = document.querySelector('.socials-band');
    if (element) {
      if (this.router.url === '/identi-professionals') {
        this.renderer.setStyle(element, 'backgroundColor', '#8396b0');
      } else {
        this.renderer.removeStyle(element, 'backgroundColor');
      }
    }
  }

  public handleLoginButtonClick() {
    if (!this.isBrowser) return;
    window.location.href = this.adminLoginUrl;
  }

  public handleJoinNowButtonClick() {
    if (!this.isBrowser) return;
    window.location.href = (this.googleformLink);
  }
}
